import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ups-card',
    template: require('./ups-card.component.html'),
    encapsulation: ViewEncapsulation.None
})
/** ups-card.component component*/
export class UpsCardComponent {
    /** ups-card.component ctor */
    constructor() {

    }
}